/* eslint-disable import/prefer-default-export */
export const skills = {
  1: [
    {
      title: 'HTML',
      level: 6,
    },
    {
      title: 'CSS',
      level: 5,
    },
    {
      title: 'Bootstrap',
      level: 5,
    },
    {
      title: 'JavaScript',
      level: 5,
    },
    {
      title: 'React',
      level: 5,
    },
    {
      title: 'Redux',
      level: 4,
    },
  ],
  2: [
    {
      title: 'MySQL',
      level: 4,
    },
    {
      title: 'PostgreSQL',
      level: 5,
    },
    {
      title: 'Rubu on Rails',
      level: 5,
    },
    {
      title: 'Git',
      level: 4,
    },
  ],
};
